import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getDashBoardTradeSuccess,
  getDashBoardTradeFailed,
  GET_DASHBOARD_TRADE_START,
} from '../../actions/dashboard'

/**
 * get dashBoard bit api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getDashBoardTradeApi = (props) => {
  var uri = `/admin/dashboard/shop`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDashBoardTrade(action) {
  try {
    const response = yield call(getDashBoardTradeApi, action?.payload)
    if (response?.statusCode !== 400) {
      yield put(getDashBoardTradeSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response)
      }
    } else {
      throw response?.message
    }
  } catch (error) {
    yield put(getDashBoardTradeFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get dashBoard bit
 */
export default function* watchGetDashBoardTrade() {
  yield takeLatest(GET_DASHBOARD_TRADE_START, doGetDashBoardTrade)
}
